import MatomoTracker from "@datapunt/matomo-tracker-js";
import * as Sentry from "@sentry/react";

const tracker =
  process.env.REACT_APP_MATOMO_URL &&
  new MatomoTracker({
    disabled: !process.env.REACT_APP_MATOMO_URL,
    siteId: process.env.REACT_APP_MATOMO_SITE_ID,
    srcUrl: process.env.REACT_APP_MATOMO_URL,
    trackerUrl: process.env.REACT_APP_MATOMO_URL,
    urlBase: process.env.REACT_APP_MATOMO_URL,
  });

export function trackEvent(category, action) {
  if (tracker) {
    tracker.trackEvent({
      action,
      category,
    });
  }

  Sentry.addBreadcrumb({
    category,
    message: action,
  });
}

export function trackPageView(href) {
  if (tracker) {
    tracker.trackPageView({
      href,
    });
  }
}
